import React from 'react'
import ModernInstagramPostContent from './components/PostContentSocials/InstagramPostContent'
import ModernTikTokPostContent from './components/PostContentSocials/TikTokPostContent'
import ModernFacebookPostContent from './components/PostContentSocials/FacebookPostContent'
import { IMediaAccounts } from './PostScheduling'

export interface PostContentProps {
  imageFiles: any[]
  setImageFiles: React.Dispatch<React.SetStateAction<any[]>>
  videoFiles: any[]
  setVideoFiles: React.Dispatch<React.SetStateAction<any[]>>
  setProfileValue: React.Dispatch<React.SetStateAction<IMediaAccounts | undefined>>
  selectedPlatform?: string
  profileValue: IMediaAccounts | undefined
  captionRef: React.MutableRefObject<string>
  tiktokAdditionalData?: {
    privacy_level: string
    allow_comments: boolean
    allow_duet: boolean
    allow_stitch: boolean
    brand_content: boolean
    brand_organic: boolean
  }
  setTiktokAdditionalData?: React.Dispatch<
    React.SetStateAction<{
      privacy_level: string
      allow_comments: boolean
      allow_duet: boolean
      allow_stitch: boolean
      brand_content: boolean
      brand_organic: boolean
    }>
  >
  postTypeValue?: string
  setPostTypeValue?: React.Dispatch<React.SetStateAction<string>>
}

export default function ModernPostContent({
  imageFiles,
  setImageFiles,
  videoFiles,
  setVideoFiles,
  setProfileValue,
  selectedPlatform,
  profileValue,
  captionRef,
  tiktokAdditionalData,
  setTiktokAdditionalData,
  postTypeValue,
  setPostTypeValue,
}: PostContentProps): JSX.Element {
  // Modern wrapper styling for content
  const wrapperStyle = {
    background: 'rgba(15, 23, 42, 0.4)',
    borderRadius: '16px',
    padding: '32px',
    border: '1px solid rgba(168, 85, 247, 0.15)',
  }

  if (selectedPlatform === 'Instagram') {
    return (
      <div style={wrapperStyle}>
        <h2
          style={{
            fontSize: '28px',
            fontWeight: 700,
            background: 'linear-gradient(135deg, #a855f7 0%, #ec4899 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: '24px',
          }}
        >
          Create Instagram Content
        </h2>
        <ModernInstagramPostContent
          imageFiles={imageFiles}
          setImageFiles={setImageFiles}
          videoFiles={videoFiles}
          setVideoFiles={setVideoFiles}
          setProfileValue={setProfileValue}
          profileValue={profileValue}
          captionRef={captionRef}
        />
      </div>
    )
  }

  if (selectedPlatform === 'TikTok') {
    return (
      <div style={wrapperStyle}>
        <h2
          style={{
            fontSize: '28px',
            fontWeight: 700,
            background: 'linear-gradient(135deg, #a855f7 0%, #ec4899 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: '24px',
          }}
        >
          Create TikTok Content
        </h2>
        <ModernTikTokPostContent
          imageFiles={imageFiles}
          setImageFiles={setImageFiles}
          videoFiles={videoFiles}
          setVideoFiles={setVideoFiles}
          setProfileValue={setProfileValue}
          profileValue={profileValue}
          captionRef={captionRef}
          tiktokAdditionalData={tiktokAdditionalData}
          setTiktokAdditionalData={setTiktokAdditionalData}
        />
      </div>
    )
  }

  if (selectedPlatform === 'Facebook') {
    return (
      <div style={wrapperStyle}>
        <h2
          style={{
            fontSize: '28px',
            fontWeight: 700,
            background: 'linear-gradient(135deg, #a855f7 0%, #ec4899 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: '24px',
          }}
        >
          Create Facebook Content
        </h2>
        <ModernFacebookPostContent
          setProfileValue={setProfileValue}
          profileValue={profileValue}
          captionRef={captionRef}
          imageFiles={imageFiles}
          setImageFiles={setImageFiles}
          videoFiles={videoFiles}
          setVideoFiles={setVideoFiles}
          postTypeValue={postTypeValue}
          setPostTypeValue={setPostTypeValue}
        />
      </div>
    )
  }

  return (
    <div
      style={{
        ...wrapperStyle,
        textAlign: 'center',
        padding: '60px 32px',
      }}
    >
      <div
        style={{
          fontSize: '48px',
          marginBottom: '16px',
        }}
      >
        🚫
      </div>
      <h3
        style={{
          fontSize: '24px',
          fontWeight: 600,
          color: 'rgba(255, 255, 255, 0.9)',
          marginBottom: '8px',
        }}
      >
        Platform Not Available
      </h3>
      <p
        style={{
          fontSize: '16px',
          color: 'rgba(255, 255, 255, 0.6)',
        }}
      >
        The selected platform is not yet supported. Please choose a different platform.
      </p>
    </div>
  )
}